import { concat, map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type ChildrenPreferenceSelectInput_query$key } from '@/__generated__/ChildrenPreferenceSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SingleSelectInputProps,
  type SingleSelectInputRef,
  type SingleSelectOption
} from '@/components'

export type ChildrenPreferenceSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: ChildrenPreferenceSelectInput_query$key | null | undefined
}

export const ChildrenPreferenceSelectInput = forwardRef<SingleSelectInputRef, ChildrenPreferenceSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment ChildrenPreferenceSelectInput_query on Query {
          childrenPreferences(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SingleSelectOption[]>(
          () =>
            concat(
              map(queryData?.childrenPreferences?.nodes, (childrenPreference) => ({
                label: childrenPreference!.name,
                value: childrenPreference!.rowId
              })),
              [{ label: 'Don’t Show This', value: null }]
            ),
          [queryData?.childrenPreferences?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

ChildrenPreferenceSelectInput.displayName = 'ChildrenPreferenceSelectInput'
